import { create } from "zustand";
import { useCertificates } from "../../useCertificates";
import { frontDB } from "../../../../frontDB";
import api from "../../../../api";
import { showToast } from "../../../../Components/Toast";
import moment from "moment";
import ConfirmationModal from "../../../../Components/ConfirmationModal/ConfirmationModal";
import { useConfirmationModal } from "../../../../Components/ConfirmationModal/useConfirmationModal";

export let useCertificatesHeader = create((set, get) => ({
  filter: {
    locationId: "*",

    certificateNameId: "*",
    certificateTypeName: "*",
    date: new Date(),
    expireRange: "*",
    status: "active",
    from: moment().utc().startOf("month").startOf("day").toDate(),
    to: moment().utc().endOf("month").startOf("day").toDate(),
  },

  setSelectedLocation: () => {
    let { location } = frontDB.getState();
    const currentLocationId = get().filter?.locationId;

    if (currentLocationId && currentLocationId !== "*") {
      return;
    }

    if (!location) {
      set({ filter: { ...get().filter, locationId: "*" } });
      return;
    }

    set({
      filter: { ...get().filter, locationId: location._id },
      vesselName: location,
    });
  },

  expireRangeHandler: (value) => {
    let fromDate = moment().utc().startOf("day").format(); //.toDate()
    let toDate = moment(fromDate).utc().add(30, "d").format();

    if (value == "Expired") toDate = fromDate;
    if (value == "7 days") toDate = moment(fromDate).utc().add(7, "d").format();
    if (value == "30 days")
      toDate = moment(fromDate).utc().add(30, "d").format();
    if (value == "60 days")
      toDate = moment(fromDate).utc().add(60, "d").format();
    if (value == "90 days")
      toDate = moment(fromDate).utc().add(90, "d").format();
    if (value == "180 days")
      toDate = moment(fromDate).utc().add(180, "d").format();
    console.log("fromDate: " + fromDate + " todate: " + toDate);
    set({
      filter: {
        ...get().filter,
        expireRange: value,
        from: fromDate,
        to: toDate,
      },
    });
  },

  locationHandler: (value) => {
    set({ filter: { ...get().filter, locationId: value } });
  },

  searchValues: { title: undefined },

  latestSearchRequest: null,

  certificateNameHandler: (certificateNameId) => {
    set({ filter: { ...get().filter, certificateNameId } });
    useCertificates.setState({ activePage: 1 });
  },

  certificateTypeNameHandler: (value) => {
    set({ filter: { ...get().filter, certificateTypeName: value } });
  },

  periodFromHandler: (v, e) => {
    if (!v) return;
    let from = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, from: v } });
  },

  periodToHandler: (v, e) => {
    if (!v) return;
    let to = moment(v).utc().startOf("day").format();
    set({ filter: { ...get().filter, to: v } });
  },

  generatingRL: false,

  onExport: async (filter, certificatesLength) => {
    //set({ generatingRL: true });
    if (!certificatesLength) {
      showToast("e", "No certificates were found in the search results.");
      return;
    }
    if (filter.locationId == "*") {
      showToast("e", "Choose a vessel name before exporting certificate list");
    } else {
      const response = await api.certificate.generateCertificatesExcel(filter);

      const fileBlob = response.data;
      if (fileBlob) {
        let { locations } = frontDB.getState();
        const vessel = locations.find((obj) => obj._id === filter.locationId);

        const now = new Date();
        const day = String(now.getDate()).padStart(2, "0");
        const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = now.getFullYear();
        const hour = String(now.getHours()).padStart(2, "0");
        const minute = String(now.getMinutes()).padStart(2, "0");
        const filename = `${vessel.name} certificates ${day}-${month}-${year}_${hour}-${minute}.xlsx`;
        const blob = new Blob([fileBlob], { type: fileBlob.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        showToast("e", "Error generating certificates export file");
      }
      set({ generatingRL: false });
    }
  },
}));

const unsubscribe = useCertificatesHeader.subscribe((newState, prevState) => {
  if (prevState.filter !== newState.filter) {
    useCertificates.setState({ activePage: 1 });
    useCertificates.getState().getCertificates();
  }
});
